var map = {
	"./scenario-0-assets/root.png": "6340",
	"./scenario-1-assets/root.png": "3f19",
	"./scenario-2-assets/root.png": "c358",
	"./scenario-3-assets/root.png": "6288",
	"./scenario-4-assets/root.png": "89ac"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c962";
module.exports = webpackAsyncContext;